<h2 class="first_title">Rubrica </h2>
<div class="content-page-wrapper">
  <div class="standardpanel">
    <div class="panel-group">
      <div class="panel panel-default">
        <div class="panel-heading">
          <div class="row">
            <h2 class="panel-title col-xs-10">
              <a data-toggle="collapse" href="#collapse1">Ricerca</a>
            </h2>
            <div class="col-xs-2">
              <a data-toggle="collapse" href="#collapse1" aria-expanded="false">
                <span class="glyphicon glyphicon-triangle-bottom"></span>
                <span class="glyphicon glyphicon-triangle-top"></span>
              </a>
            </div>
          </div>
        </div>
        <div id="collapse1" class="panel-collapse collapse">
    
          <div class="panel-body">
            <label for="">Tipo persona</label> <span class="mandatory ">*</span>
            <select class="form-control" [(ngModel)]="personTypeSelect" style="margin-bottom: 15px;">
              <option [ngValue]="null">Seleziona tipo di persona</option>
              <option *ngFor="let person of personType" [ngValue]="person">{{person.name}}</option>
            </select>
            <div *ngIf="personTypeSelect==null" class="row">
              <div class="col-xs-12 col-sm-6"></div>
              <div class="col-xs-6 col-sm-3">
                <button class="btn-secondary btn btn-block" type="button" (click)="resetForm()">
                  Reset
                </button>
              </div>
              <div class="col-xs-6 col-sm-3">
                <button class="btn-primary btn btn-block" type="button" (click)="getAllPersons()">
                  Ricerca
                </button>
              </div>
            </div>
            <div *ngIf="personTypeSelect != null">
              <app-dynamic-form *ngIf="personTypeSelect.id === 'PHYSICAL_ENTITY'" [questions]="formFieldsPhysical"
                [config]="formConfiguration" (onFormSubmit)="onSearch($event,personTypeSelect.id)"
                (onFormReset)="resetForm()"></app-dynamic-form>
              <app-dynamic-form *ngIf="personTypeSelect.id === 'LEGAL_ENTITY'" [questions]="formFieldsLegal"
                [config]="formConfiguration" (onFormSubmit)="onSearch($event,personTypeSelect.id)"
                (onFormReset)="resetForm()"></app-dynamic-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="titleblock">
      <h3 class="title1levelNoMargin">
        Gestione Personale
      </h3>
      <p>
        <a (click)='addPerson()' href="javascript:void(0)">
          Aggiungi persona
          <span class="glyphicon glyphicon-plus-sign"></span>
        </a>
      </p>
    </div>
    <div class="titleblock">
      <h3 class="title1level" style="padding: 25px 0px 0px 0px; margin-top: -10px"></h3>
      <p style="margin-top: -45px">
        <a (click)="updateList()" href="javascript:void(0)">
          Aggiorna
          <span style="margin-left: 5px;" class="glyphicon glyphicon-refresh"></span>
        </a>
      </p>
    </div>
    
    <div class="container_dati_generali">
      <app-person-list [personTypes]="personType" (editPerson)="onEditPerson($event)"
        (deletePerson)="onDeletePerson($event)"
        [personList]="personList != undefined ? personList.items : []"></app-person-list>
      <div class="card-pagination">
        <app-pagination
          [resetCurrentPage]="resetCurrentPage"
          [totalItems]="personList != undefined ? personList.totalItems : 0"
          [hasAutoRefresh]="true"
          (refreshEvent)="updateList($event)">
        </app-pagination>
    
      </div>
    </div>
  </div>
</div>

